import React from "react";

import Button from "components/Button";

import { Node } from "types/explain";

import styles from "./style.module.scss";
import { useSelectedNode } from "../../WithExplainNodeSelection";

const CTEInfo: React.FunctionComponent<{
  node: Node;
}> = ({ node }) => {
  const isCTE = node["CTE Name"] != null;
  const isCTESubplan = (node["Subplan Name"] as string)?.startsWith("CTE ");
  const [, setSelectedNode] = useSelectedNode();
  const onClick = () => setSelectedNode(String(node["CTE Name"]));

  if (!isCTE && !isCTESubplan) {
    return null;
  }

  const cteName = String(node["CTE Name"]);
  const cteSubplanName = String(node["Subplan Name"]);
  return (
    <div className={styles.cteInfo}>
      {isCTESubplan && <span title={cteSubplanName}>{cteSubplanName}</span>}
      {isCTE && (
        <Button bare title={cteName} onClick={onClick}>
          {cteName}
        </Button>
      )}
    </div>
  );
};

export default CTEInfo;
